module.exports = __webpack_public_path__ + "media/images/icon/ico_top_flow02-afbb9c03a8305283189610ee0b3eebdc.svg";